import Model from './Model'

export default class PaymentCertificate extends Model
{
    static async all () {
        const { data } = await Http.get(route('api.v1.pcs.due'))
        return this.make(data)
    }
}
